import { EmployerBasics } from "../../../features/employerDashboard/employerDashboardSlice/employerProfileCreation/EmployerBasics";

export function EmployerBasicsPage() {
  return (
    <div>
      <EmployerBasics />
    </div>
  );
}
